import {
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  MENU_ARGS,
  pickArgs,
} from '../../../../../utils/spds/metadata';
import { BOOLEAN } from '../../../../../utils/component-validations';
import { fn, hash } from '@ember/helper';
import { tracked } from '@glimmer/tracking';
import FlexRow from '../../../layout/flex/row.gjs';
import Menu from './menu.gjs';
import Super from '../../../core/base.gjs';
import Trigger from './trigger.gjs';
import styles from './base.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Filter',
  description: 'Base filter button component with menu',
  meta: {
    ...pickArgs(ACTION_ARGS, ['onClick']).meta,
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled', 'open']).meta,
    ...pickArgs(CONTAINER_ARGS, ['fitContent']).meta,
    ...pickArgs(CONTENT_ARGS, ['text']).meta,
    ...pickArgs(MENU_ARGS, ['menuAnchorOffset', 'menuFitContent']).meta,
    filtered: {
      type: BOOLEAN,
      description: 'Indicates if the filter is active',
      defaultValue: false,
    },
    onSelect: {
      ...ACTION_ARGS.meta.onClick,
      description: 'Action triggered when a menu item is selected',
    },
  },
  name: 'Filter Button',
};

export default class SpdsActionButtonFilterBase extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-filter';
  classesToMapToArgs = ['filtered'];
  componentName = 'Spds::Action::Button::Filter';
  styles = styles;

  constructor() {
    super(...arguments);

    this.arguments = this.composeArguments(METADATA);
  }

  @tracked menuComponent;
  @tracked menuTriggerComponent;

  get menuAnchor() {
    return this.menuTriggerComponent?.baseElement;
  }

  get open() {
    return !!this.args.open;
  }

  <template>
    <FlexRow
      @fitContent={{true}}
      class={{this.classes}}
      data-test-spds-action-button-filter
      {{this.setupComponent}}
      {{this.validateArguments}}
      ...attributes
    >
      {{yield
        (hash
          Menu=(component
            Menu
            anchorElement=this.menuAnchor
            anchorOffset=@menuAnchorOffset
            fitContent=@menuFitContent
            onSelect=@onSelect
            open=this.open
            registerComponent=(fn this.registerComponent "menuComponent")
            unregisterComponent=(fn this.unregisterComponent "menuComponent")
          )
          Trigger=(component
            Trigger
            disabled=@disabled
            fitContent=@fitContent
            onClick=@onClick
            open=this.open
            registerComponent=(fn this.registerComponent "menuTriggerComponent")
            text=@text
            unregisterComponent=(fn this.unregisterComponent "menuTriggerComponent")
          )
        )
      }}
    </FlexRow>
  </template>
}

export const ACTION_BUTTON_FILTER_BASE_METADATA = SpdsActionButtonFilterBase.metadata;
